import { useState } from 'react'
import { RETURN_REASON_CODES } from '@components/returns/consts'
import { Returns } from '@api/returns/types'
import { Fit } from 'types/fit'

function checkHasReturnedProductWithFitReason(returns: Returns = {}) {
  const productReturnReasons = Object.values(returns)
    .flatMap(returnsData => returnsData.products)
    .map(product => product?.return?.reason)

  return productReturnReasons.some(
    reason => Number(reason) === RETURN_REASON_CODES.FIT_NOT_RIGHT
  )
}

type UseReturnCompletedUpdateFitModalProps = {
  returns?: Returns
  customerFit: Fit | undefined
  querySuccessReturn: string
}

export default function useReturnCompletedUpdateFitModal({
  returns,
  customerFit,
  querySuccessReturn
}: UseReturnCompletedUpdateFitModalProps) {
  const [
    showReturnCompletedUpdateFitModal,
    setShowReturnCompletedUpdateFitModal
  ] = useState(true)

  const shouldShowReturnCompletedUpdateFitModal =
    !!querySuccessReturn &&
    customerFit &&
    checkHasReturnedProductWithFitReason(returns) &&
    showReturnCompletedUpdateFitModal

  return {
    shouldShowReturnCompletedUpdateFitModal,
    setShowReturnCompletedUpdateFitModal
  }
}
